import { Icons } from './assets';

export default {
    certification: {
        icon: Icons.certification,
        text:[
            "COMS is on a mission to improve moringa leaf farming and processing in order to meet sanitary and nutritional standards.",
            "Apply for your certification today."
        ],
        action: "Get certified organic",
        path: "certification"

    },
    invest: {
        icon: Icons.learn,
        text: [
            "Moringa Oleifera is an exceptional resource for developing countries.",
            "This “Superfood” is a nutritionally rich vegetable available in nations with tropical and subtropical climate."
        ],
        path: "about",
        action: "Learn more"
    },
    learn: {
        icon: Icons.invest,
        text: [
            "Moringa leaves were ranked top vegetable by the World Vegetable Center (AVRDC).",
            "The moringa leaf is a new promising source of income, sustainable             agriculture and business growth."
        ],
        path: "cultivation",
        action: "Invest in moringa"
    }
}